module.exports = __webpack_public_path__ + "img/pacificmeta.fa17fdea.png";